function ProofOfDelivery() {
  return <div><h2>Proof of Delivery</h2><p>Proof of delivery upload will go here.</p></div>;
}
export default ProofOfDelivery; 